import { render } from "./RegistrationRequestList.vue?vue&type=template&id=32638a39"
import script from "./RegistrationRequestList.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestList.vue?vue&type=script&lang=js"

import "./RegistrationRequestList.vue?vue&type=style&index=0&id=32638a39&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__